import { ApiError } from '../services/apiClient';

type UnknownRecord = Record<string, unknown>;

function asRecord(value: unknown): UnknownRecord | null {
  return value && typeof value === 'object' ? (value as UnknownRecord) : null;
}

function readErrorCode(data: unknown): string | null {
  const root = asRecord(data);
  if (!root) return null;
  const direct = root.error_code;
  if (typeof direct === 'string' && direct.trim()) return direct;
  const detail = asRecord(root.detail);
  const nested = detail?.error_code;
  if (typeof nested === 'string' && nested.trim()) return nested;
  return null;
}

function readProvider(data: unknown): string | null {
  const root = asRecord(data);
  if (!root) return null;
  const direct = root.provider;
  if (typeof direct === 'string' && direct.trim()) return direct;
  const detail = asRecord(root.detail);
  const nested = detail?.provider;
  if (typeof nested === 'string' && nested.trim()) return nested;
  return null;
}

export function getReconnectErrorMeta(error: unknown): { requiresReconnect: boolean; provider?: string } {
  if (!(error instanceof ApiError)) return { requiresReconnect: false };
  const code = readErrorCode(error.data);
  if (code !== 'EMAIL_PROVIDER_RECONNECT_REQUIRED') return { requiresReconnect: false };
  return {
    requiresReconnect: true,
    provider: readProvider(error.data) || undefined,
  };
}
